import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Slider from "react-slick"
import kfcams from '../../assets/kfin.svg'
import angleIcon from '../../assets/landing-page/angle-right.svg'
import commercialImg from '../../assets/landing-page/commercial-transaction.svg'
import commercialImg1 from '../../assets/landing-page/commercial.svg'
import eCasImg1 from '../../assets/landing-page/ecas-1.svg'
import eCasImg2 from '../../assets/landing-page/ecas2.svg'
import GraphImg from '../../assets/landing-page/graph-3d.svg'
import LAMFImg from '../../assets/landing-page/lamf.svg'
import nonCommercialImg from '../../assets/landing-page/non-commercial-transaction.svg'
import nonCommercialImg1 from '../../assets/landing-page/non-commercial.svg'
import eclipse from '../../assets/shapes/bg-eclipse.svg'
import FAQ from '../../components/FAQ/FAQ'
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'
import useAuth from '../../hooks/useAuth'
import { getDetails, getWithoutCredentials } from '../../services/http/http.service'
import StorageService from '../../services/storage/storage.service'
import { setRedirectionUrl, setShowCallToCTA, setShowCTAModal, setShowLoginModal } from '../../store/authentication/authentication.slice'
import { setFilterName } from '../../store/pageData/pageData.slice'
import { setCart } from '../../store/selectedAPIs/selectedAPIs.slice'
import { useAppDispatch } from '../../store/storeRequests'
import APIList from '../../utils/constants/APIList'
import { APIResponseCodes } from '../../utils/constants/keys.constants'
import './landing-page.css'
import { NavList } from '../../utils/constants/navigation'

const LandingPage: React.FunctionComponent<any> = () => {

  const swiperElRef = useRef<Slider | null>(null)
  const apiCallStatus = useRef(false)
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentUser = useAuth()

  let settings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const [FAQData, setFAQData] = useState([])
  const [heroTitle, setHeroTile] = useState('Mark Lien, Unpledge, Invoke')
  const [count, setCount] = useState(1)

  const getFAQ = async () => {
    const response = await getWithoutCredentials(APIList.GET_FAQ + '?identifier=home&status=1')
    if (response?.statusCode === APIResponseCodes.SUCCESS) {
      setFAQData(response.data)
    }

  }

  const getAllCartItems = async () => {
    const response = await getDetails(APIList.GET_CART_ITEMS, getAllCartItems)
    if (response?.statusCode === APIResponseCodes.SUCCESS) {
      dispatch(setCart(response.data))
    }

  }

  useEffect(() => {

    if (apiCallStatus.current === false) {
      getFAQ()

      if (currentUser === 1 || currentUser === 2) {

        const { user } = StorageService.getFromStorage(['user'])
        if (typeof user?.token === 'string') {
          getAllCartItems()
        }
      }
      return
    }
    apiCallStatus.current = true

  }, [])

  useEffect(() => {

    const list = ['Mark Lien, Unpledge, Invoke', 'Consolidated Statement Reports', 'Commercial Transactions', 'Updation of Records']

    const interval = setInterval(() => {
      if (count < 4) {
        setHeroTile(list[count])
        setCount(count + 1)
      } else {
        setCount(1)
        setHeroTile('Mark Lien, Unpledge, Invoke')
      }
    }, 1500);

    return () => {
      clearInterval(interval);
    };
  }, [count]);

  const openLoginModal = (option: any) => {
    const { user } = StorageService.getFromStorage(['user']);
    dispatch(setFilterName(option));
    if (typeof user?.token === 'string') {
      navigate(NavList.MARKET_PLACE);
    } else {
      dispatch(setShowLoginModal(true));
      dispatch(setRedirectionUrl(NavList.MARKET_PLACE))
    }
  };

  const openCTAModalonLoggedout = () => {
    // const { user } = StorageService.getFromStorage(['user']);

    // if (typeof user?.token === 'string') {
      openLoginModal('all');
    // } else {      
    //   dispatch(setShowCTAModal(true));
    // }
  }

  const openCallToCTA = () => {
      dispatch(setShowCallToCTA(true));
  }
  return (
    <section id='landingPage' className='landing-page'>

      <Header />

      <div className="hero-section pb-4">
        <div className="hero-content-container">
          <div className="row no-negative-margin align-items-center">
            <div className="col-12 col-md-12 col-lg-6 hero-text-content mb-lg-4">
              <div className='text-primary-color hero-line-top mb-3 mb-lg-4'><span className='d-block'></span></div>
              <p className='font-18 weight-700 text-sec-color hero-title'>{heroTitle}</p>
              <p className='text-primary-color font-16 weight-400 hero-lead-subtitle'>Use a unified API journey for transactions and consolidated reports agnostic of RTAs.</p>
              <button
                onClick={() => openCTAModalonLoggedout()}
                type='button' className='hero-action-btn text-capitalize weight-400 text-white secondary-bg-color border-0 mt-3 mt-md-5 mt-lg-5 mt-xl-4 mb-3 mb-md-0 mb-lg-0'>Get Started</button>
            </div>
            <div className="col-12 col-md-12 col-lg-6 hero-cards-content my-5 my-md-5 my-lg-0">
              <div className="hero-cards">
                <div className="d-flex justify-content-end me-0 me-md-5 me-lg-5">
                  <div className="hero-card hero-card-non-commercial card-shadow d-flex flex-nowrap p-3">
                    <p className="mb-0 text-primary-color weight-600 text-start font-16 text-capitalize">Non commercial transactions</p>
                    <img width="150" height="90" src={nonCommercialImg1} alt="non commercial transactions" />
                  </div>
                </div>

                <div className="hero-cards-vert-spacing d-flex align-items-start justify-content-end flex-nowrap">
                  <div className="hero-card hero-card-e-cas card-shadow p-3">
                    <div className="ecas-img-container d-flex flex-nowrap ms-2">
                      <img className='card-shadow primary-bg-color py-2' width="90" height="95" src={eCasImg1} alt="e-CAS" />
                      <img className='card-shadow bg-white py-2 ms-3' width="90" height="95" src={eCasImg2} alt="e-CAS" />
                    </div>
                    {/* <p className="mb-0 text-primary-color weight-600 text-start font-16 mt-3">e-CAS</p> */}
                    <p className="mb-0 text-primary-color weight-600 text-start font-16 mt-3">Read Only</p>
                  </div>

                  <div className="position-relative d-none d-md-block d-lg-block">
                    <img className='hero-bg-img3 position-absolute' src={eclipse} alt="background" />
                    <div className="hero-card hero-card-commercial card-shadow p-3">
                      <p className="mb-0 text-primary-color weight-600 text-start font-16 text-capitalize">commercial transactions</p>
                      <div className="text-end w-100 mt-2">
                        <img width="200" height="135" src={commercialImg1} alt="commercial transactions" />
                      </div>
                    </div>
                  </div>

                </div>

                <div className="position-relative d-block d-md-none d-lg-none mt-5">
                  <img className='hero-bg-img3 position-absolute' src={eclipse} alt="background" />
                  <div className="hero-card hero-card-commercial card-shadow p-3">
                    <p className="mb-0 text-primary-color weight-600 text-start font-16 text-capitalize">commercial transactions</p>
                    <div className="text-end w-100 mt-2">
                      <img width="200" height="135" src={commercialImg1} alt="commercial transactions" />
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-end">
                  <div className="hero-card hero-card-lamf card-shadow p-3">
                    <div className="">
                      <p className="mb-0 text-primary-color weight-600 text-start font-16 text-uppercase">LAMF</p>
                      <img className='mt-2' width="120" height="110" src={LAMFImg} alt="LAMF" />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="types-swiper">
        <div className="types-swiper-head text-center position-relative">
          <h2 className='font-26 weight-700 text-sec-color'>API Categories</h2>
          <div className="types-swiper-action-btns d-none d-md-block d-lg-block">
            <button className='types-swiper-prev border-0 me-3' type='button' onClick={() => swiperElRef.current?.slickPrev()}>
              <img width={18} height={18} className='icon-rotate-180' src={angleIcon} alt="prev" />
            </button>
            <button className='types-swiper-next border-0' type='button' onClick={() => swiperElRef.current?.slickNext()}>
              <img width={18} height={18} src={angleIcon} alt="next" />
            </button>
          </div>
        </div>

        <div className="types-swiper-content pt-3 pt-md-5 pt-lg-5 pb-0 cursor-pointer">

          <div className="" style={{ overflow: 'hidden' }}>
            <Slider ref={swiperElRef} {...settings} draggable={true}>
              <div>
                <div className="types-swiper-card d-flex m-3 align-items-start" onClick={() => openLoginModal('e-CAS')} >
                  <img className='primary-bg-color types-swiper-img me-3' width={60} height={60} src={eCasImg1} alt="cas" />
                  <div className="">
                    <p className="mb-0 text-uppercase text-primary-color weight-600 font-16 mb-2">CAS</p>
                    <p className="mb-0 text-primary-color weight-400 font-14 types-swiper-card-dec">Consolidated Mutual Fund Account Statement</p>
                  </div>
                </div>
              </div>
              <div>
                <div className="types-swiper-card d-flex m-3 align-items-start" onClick={() => openLoginModal('LAMF')}>
                  <div className="types-swiper-img-lamf">
                    <img className='types-swiper-img me-3' width={60} height={60} src={LAMFImg} alt="LAMF" />
                  </div>
                  <div className="">
                    <p className="mb-0 text-capitalize text-primary-color weight-600 font-16 mb-2">Loan Against Mutual Fund</p>
                    <p className="mb-0 text-primary-color weight-400 font-14 types-swiper-card-dec">Pledge, Un pledge APIs for Mutual Fund units</p>
                  </div>
                </div>
              </div>
              <div>
                <div className="types-swiper-card d-flex m-3 align-items-start" onClick={() => openLoginModal('Non Commercial Transactions')}>
                  <div className="types-swiper-img-noncommercial">
                    <img className='types-swiper-img me-3' width={80} height={70} src={nonCommercialImg} alt="Non transactional" />
                  </div>
                  <div className="">
                    <p className="mb-0 text-capitalize text-primary-color weight-600 font-16 mb-2">Non Commercial Transactions</p>
                    <p className="mb-0 text-primary-color weight-400 font-14 types-swiper-card-dec">Updation of Mobile, Email, Bank details etc</p>
                  </div>
                </div>
              </div>
              <div>
                <div className="types-swiper-card d-flex m-3 align-items-start" onClick={() => openLoginModal('Commercial Transactions')}>
                  <div className="types-swiper-img-commercial">
                    <img className='types-swiper-img me-3' width={70} height={70} src={commercialImg} alt="Commercial Transactions" />
                  </div>
                  <div className="">
                    <p className="mb-0 text-capitalize text-primary-color weight-600 font-16 mb-2">Commercial Transactions</p>
                    <p className="mb-0 text-primary-color weight-400 font-14 types-swiper-card-dec">SIP, SWP, STP, Purchase, Redemption etc</p>
                  </div>
                </div>
              </div>
            </Slider>
          </div>

          <div className="types-swiper-action-btns d-block d-md-none d-lg-none">
            <button className='types-swiper-prev border-0 me-4 me-md-3 me-lg-3' type='button' onClick={() => swiperElRef.current?.slickPrev()}>
              <img width={18} height={18} className='icon-rotate-180' src={angleIcon} alt="prev" />
            </button>
            <button className='types-swiper-next border-0' type='button' onClick={() => swiperElRef.current?.slickNext()}>
              <img width={18} height={18} src={angleIcon} alt="next" />
            </button>
          </div>

        </div>
      </div>

      {/* ======== NEW BANNER SECTION ======== */}
      <div className="usecase-banner text-center py-5 px-3">
        <h2 className="font-32 weight-700 text-primary-color mb-3">
          The Future is Co-Created. Let's Build It.
        </h2>

        <p className="font-16 weight-400 text-sec-color mx-auto mb-4" style={{ maxWidth: "700px" }}>
          We invite you to submit the use cases you've always wanted to build.
          The most compelling collaborations to frame the next big use case for capital markets.
        </p>

        <button
          className="cta-btn primary-bg-color text-white px-4 py-2 rounded border-0"
          onClick={() => openCallToCTA()}
        >
          Submit Your Vision
        </button>
      </div>
      {/* ============================================================ */}

      <div className="product-developers primary-bg-color d-flex align-items-center justify-content-center">
        <div className="primary-bg-color product-developers-content my-5">
          <div className="row align-items-center justify-content-between">
            <div className="col-12 col-md-6 col-lg-6 d-flex flex-column justify-content-between">
              <p className="product-developers-title text-white weight-700 mb-4 mb-md-4 mb-lg-5">
                Unlock Financial Innovation
              </p>

              <p className="text-white weight-400 font-16 line-height-26 mb-4">
                The essential API marketplace for builders and visionaries.
                Trusted by over <strong>300+ digital platforms</strong> powering investments,
                lending, and other capital markets use cases.
              </p>

              <p className="mb-0 product-developers-subtitle text-white weight-400 font-16 mb-3 mt-lg-5 pt-lg-4">
                Brought to you by
              </p>
              <img className='kfintech-cams-img' width="350" height="76" src={kfcams} alt="KFintech" />
            </div>
            <div className="col-12 col-md-6 col-lg-6 p-developers-img position-relative">
              <img className='position-relative' style={{ zIndex: 40 }} width="450" height="450" src={GraphImg} alt="graph" />
            </div>
          </div>
        </div>
      </div>

      <div className="landing-faq-section">
        <h2 className='font-26 weight-700 text-sec-color text-center'>FAQ's</h2>
        <div className="landing-faq-container mt-5">
          <FAQ FAQData={FAQData} />
        </div>
      </div>

      <Footer />
    </section>

  )
}

export default LandingPage